import { useMutationObserver } from './useMutationObserver'

export const useSetRDIFrameTitle = () => {
  const callback: MutationCallback = (mutationList) => {
    mutationList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes)
        const rdIframe = addedNodes.find(
          (node) =>
            node.nodeName === 'IFRAME' &&
            (node as Element).getAttribute('id') === 'rd_tmgr',
        )

        if (rdIframe) {
          const iframe = rdIframe as HTMLIFrameElement
          iframe.setAttribute('title', 'RD Station Iframe')
        }
      }
    })
  }

  useMutationObserver({
    callback,
    options: {
      childList: true,
    },
  })
}
